import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardHeader, CardBody, Form, FormGroup, Label, Input, Button, Row, Col, Container } from "reactstrap";

const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};


function AssetForm() {
  const [formData, setFormData] = useState({
    name: "",
    category: "",
    description: "",
    department: "",
    segments: "",
    specification: "",
    criticality: "",
    internal_external: "",
    value: ""
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const authUser = JSON.parse(sessionStorage.getItem("authUser"));
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/assets/assetdetails`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(authUser?.token && { Authorization: `Bearer ${authUser.token}` }),
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) throw new Error("Failed to save asset");
      const data = await response.json();
      console.log("Asset saved:", data);

      setFormData({
        name: "",
        category: "",
        description: "",
        department: "",
        segments: "",
        specification: "",
        criticality: "",
        internal_external: "",
        value: ""
      });

      navigate("/AssetManagement");
    } catch (err) {
      console.error("Error saving asset:", err);
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Card style={cardShell}>
          <CardHeader className="bg-primary">
            <h4 className="mb-0 text-white">Add Asset Details</h4>
          </CardHeader>
          <CardBody>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label for="name">Asset Name</Label>
                    <Input id="name" name="name" type="text" value={formData.name} onChange={handleChange} required />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label for="category">Category</Label>
                    <Input id="category" name="category" type="text" value={formData.category} onChange={handleChange} />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label for="department">Department</Label>
                    <Input id="department" name="department" type="text" value={formData.department} onChange={handleChange} />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label for="description">Description</Label>
                    <Input id="description" name="description" type="textarea" value={formData.description} onChange={handleChange} />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label for="segments">Segments</Label>
                    <Input id="segments" name="segments" type="text" value={formData.segments} onChange={handleChange} />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label for="specification">Specification</Label>
                    <Input id="specification" name="specification" type="text" value={formData.specification} onChange={handleChange} />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label for="criticality">Criticality</Label>
                    <Input id="criticality" name="criticality" type="select" value={formData.criticality} onChange={handleChange}>
                      <option value="">Select</option>
                      <option value="High">High</option>
                      <option value="Medium">Medium</option>
                      <option value="Low">Low</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label for="internal_external">Internal/External</Label>
                    <Input id="internal_external" name="internal_external" type="select" value={formData.internal_external} onChange={handleChange}>
                      <option value="">Select</option>
                      <option value="Internal">Internal</option>
                      <option value="External">External</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label for="value">Value</Label>
                    <Input id="value" name="value" type="number" value={formData.value} onChange={handleChange} />
                  </FormGroup>
                </Col>
              </Row>
              <div className="d-flex justify-content-center gap-5">
                <Button type="submit" color="primary">Save Asset</Button>
                <Button
                  type="button"
                  color="secondary"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </Button>

              </div>
            </Form>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
}

export default AssetForm;
